<script>
import { mapState, mapActions } from 'vuex';
import collect from 'collect.js';

export default {
    data() {
        return {
            bodyEl: document.getElementsByTagName('body')[0],
            mouseIsDown: false
        };
    },
    computed: {
        ...mapState('spinner', [
            'raycaster',
            'camera',
            'renderer',
            'hotspots',
            'mouse'
        ])
    },
    render() {
        return null;
    },
    mounted() {
        this.enable();
    },
    destroyed() {
        this.disable();
    },
    methods: {
        ...mapActions(['setCurrentHotspot']),
        ...mapActions('spinner', [
            'changeHotspotTextureMap',
            'turnOffInactiveHotspots'
        ]),
        enable() {
            setTimeout(() => {
                document.addEventListener(this.$root.mouseDown, this.onMouseDown);
                document.addEventListener(this.$root.mouseOut, this.onMouseOut);
                document.addEventListener(
                    this.$root.mouseMove,
                    this.onMouseMove,
                    false
                );
            }, 500);
        },

        disable() {
            document.removeEventListener(
                this.$root.mouseDown,
                this.onMouseDown
            );
            document.removeEventListener(this.$root.mouseOut, this.onMouseOut);
            document.removeEventListener(
                this.$root.mouseMove,
                this.onMouseMove
            );
        },

        onMouseMove(event) {
            if (this.$root.mouseMove == 'mousemove') {
                event.preventDefault();
            }
            this.setMouse(event);
            if (!this.mouseIsDown) {
                this.intersect(event);
            }
        },

        onMouseDown(event) {
            this.mouseIsDown = true;
            this.addListeners();
            this.setMouse(event);
            if (this.$root.mouseDown == 'mousedown') {
                event.preventDefault();
            }
            this.intersect(event);
        },

        onMouseUp() {
            this.removeMoveListeners();
            this.stop();
        },

        onMouseOut() {
            this.removeMoveListeners();
            this.stop();
        },

        stop() {
            this.mouseIsDown = false;
        },

        addListeners() {
            document.addEventListener(
                this.$root.mouseUp,
                this.onMouseUp,
                false
            );
        },
        removeMoveListeners() {
            document.removeEventListener(
                this.$root.mouseUp,
                this.onMouseUp,
                false
            );
        },

        // eslint-disable-next-line no-unused-vars
        intersect(event) {
            if (event.target.matches('canvas')) {
                this.raycaster.setFromCamera(this.mouse, this.camera);
                let intersects = this.raycaster.intersectObjects(
                    collect(this.hotspots)
                        .pluck('object')
                        .all(),
                    true
                );
                if (intersects.length > 0) {
                    const hotspot = intersects[0].object;
                    // eslint-disable-next-line no-console
                    // console.log(intersects);
                    if (hotspot) {
                        if (event.type == 'mousemove') {
                            this.changeHotspotTextureMap({
                                type: 'selected',
                                name: hotspot.name
                            });
                            this.bodyEl.style.cursor = 'pointer';
                        } else {
                            // eslint-disable-next-line no-console
                            // console.log(intersects[0].object.name);
                            this.setCurrentHotspot(hotspot.name);
                        }
                    }
                } else {
                    this.turnOffInactiveHotspots();
                    this.bodyEl.style.cursor = 'default';
                }
            }
        },

        setMouse(event) {
            // eslint-disable-next-line no-console
            // console.log(event);
            if (window.TouchEvent && event instanceof TouchEvent) {
                event = event.touches[0];
            }
            this.mouse.clientX = event.clientX;
            this.mouse.clientY = event.clientY;
            this.mouse.x =
                (event.clientX / this.renderer.domElement.clientWidth) * 2 - 1;
            this.mouse.y =
                -(event.clientY / this.renderer.domElement.clientHeight) * 2 +
                1;
            // eslint-disable-next-line no-console
            // console.log(
            //     this.mouse,
            //     event,
            //     this.renderer.domElement.clientWidth,
            //     this.renderer.domElement.clientHeight
            // );
        }
    }
};
</script>

<style></style>
